/**
 * Lightweight analytics client.
 *  - Generates & persists a session_id in sessionStorage so we can dedupe unique
 *    visitors per browser session without cookies.
 *  - Fires a page-view to the backend on every route change.
 *  - Bot/admin paths are still sent (server filters out crawlers by UA).
 */
import { api } from "./api";

const SESSION_KEY = "paws_session_id";

function getSessionId() {
  try {
    let sid = window.sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 40);
      window.sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "";
  }
}

export async function trackPageView(path) {
  try {
    await api.post(
      "/track/pageview",
      {
        path: path || window.location.pathname,
        session_id: getSessionId(),
        referrer: document.referrer || null,
      },
      { timeout: 5000 }
    );
  } catch {
    /* ignore — analytics must never break the app */
  }
}
